export default __webpack_public_path__ + "static/media/l-intro-img-3.2724e17a.svg";